import React from "react";
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Modal from '@mui/material/Modal';
import { useState } from "react";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
var search = require('youtube-search');



function FindActivities(){
    let interests="";
    const myStyle={
        margin:"0px",
        paddingTop:"100px",
        height:"100vh",
    }
    let [videos,setVideos]=useState([]);
    var opts = {
        maxResults: 3,
        key: 'AIzaSyCBIO5P-Gnen0n9Ms0rxlj8R6EaZlBRNUg',
     };
    function findActivities(interests){
        let interest=interests.split(",");
        console.log(interest);
        let result=[];
        interest.forEach((r)=>{
            search(r,opts,(err,results)=>{
                if(err)return console.log(err);
                console.log(results);
                results.forEach((v)=>{
                    result.push("https://www.youtube.com/embed/"+v.id);
                })
            })
        });
        // console.log(result);
        setVideos(result);
        console.log(result);
        


        
    }
    
    

   
    return (
        <div style={myStyle} align="center"  className="App bg-gradient-to-r from-cyan-500 to-blue-500">
            
            <TextField label="Enter your interests" variant="outlined" color="error" focused onChange={(e)=>{interests=e.target.value}}/>
            <Button variant="contained" onClick={()=>{findActivities(interests)}}>Submit</Button>
            {videos.map((video)=>{
                return <Card>
                    <CardContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        video
                        </Typography>
                        <iframe width="420" height="315"
                        src={videos}>
                        </iframe>
                    </CardContent>
                    </Card>
            })}
            
        </div>
    );
}

export default FindActivities;